import { DialogueData } from '../../atoms/dialogue';

const dialogue_puzzle1_05: DialogueData = {
	name: 'Dispatch',
	messages: { 
		
		// start message         
		'dialogue_puzzle1_05_00':{
			speakingCharacter: 0,
			followupMessage: 'dialogue_puzzle1_05_01'
		},
		'dialogue_puzzle1_05_01':{
			speakingCharacter: 0,
		},
	}
};

export default dialogue_puzzle1_05;